import { render } from "./FooterV.vue?vue&type=template&id=5959b6b0&ts=true"
import script from "./FooterV.vue?vue&type=script&lang=ts"
export * from "./FooterV.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__